// extracted by css-extract-rspack-plugin
export default {"jsonViewContainer":"jsonViewContainer-c0JyqH","jsonViewWrapper":"jsonViewWrapper-fcdzp0","header":"header-JFmSA8","actions":"actions-IapC7x"};